/**
 * Badge mail spedizione Itamoby/Ityhome (Davide 2026-07-03).
 *
 * Stesso contratto a 3 stati del MailStatusBadge AS/WF:
 * - confirmed_imap — scanner Sent (`pickup_mail_scanner`) ha trovato la
 *   mail reale → raw.ldv_mail_inviata=true
 * - pending_imap — l'app ha inviato (raw.pickup_mail_app_sent_at) ma lo
 *   scanner non ha ancora confermato
 * - never_sent — nessuna evidenza
 */

import { apiPost } from "@/shared/api";
import type { AllServiceMailStatusDetail, AllServiceMailStatusState } from "./allserviceApi";

/** Destinatari pickup per fornitore — speculari a PICKUP_SUPPLIER_EMAILS
 *  nel backend (orders/service.py). */
export const PICKUP_RECIPIENTS: Record<string, string> = {
  itamoby: "info@itamoby.com",
  ityhome: "info@ityhome.com",
};

export type PickupVerifyMailResult = {
  order_id: number;
  reference: string;
  status: AllServiceMailStatusDetail;
  scan_metrics: Record<string, unknown>;
};

export function verifyPickupMailSent(orderId: string): Promise<PickupVerifyMailResult> {
  return apiPost<PickupVerifyMailResult>(
    `/api/orders/${encodeURIComponent(orderId)}/verify-pickup-mail-sent`,
  );
}

/** Estrae lo stato mail pickup dal raw dell'Order (no fetch) — speculare
 *  a `derive_pickup_mail_status` backend (orders/schemas.py). Usato dai
 *  badge in lista per evitare N round-trip. */
export function derivePickupMailStatusFromRaw(
  raw: Record<string, unknown> | null | undefined,
  supplierKind: string,
): AllServiceMailStatusDetail {
  const r = raw ?? {};
  const appSent =
    typeof r.pickup_mail_app_sent_at === "string" && r.pickup_mail_app_sent_at
      ? r.pickup_mail_app_sent_at
      : null;
  const confirmed = r.ldv_mail_inviata === true;
  const confirmedAt =
    confirmed && typeof r.ldv_mail_inviata_il === "string" ? r.ldv_mail_inviata_il : null;

  let state: AllServiceMailStatusState;
  if (confirmed) state = "confirmed_imap";
  else if (appSent) state = "pending_imap";
  else state = "never_sent";

  return {
    state,
    app_sent_at: appSent,
    app_message_id:
      typeof r.pickup_mail_app_message_id === "string" ? r.pickup_mail_app_message_id : null,
    app_attachment:
      typeof r.pickup_mail_app_attachment === "string" ? r.pickup_mail_app_attachment : null,
    app_attempts: typeof r.pickup_mail_app_attempts === "number" ? r.pickup_mail_app_attempts : 0,
    imap_confirmed_at: confirmedAt,
    imap_message_id: typeof r.ldv_mail_message_id === "string" ? r.ldv_mail_message_id : "",
    imap_attachment: typeof r.ldv_mail_attachment === "string" ? r.ldv_mail_attachment : "",
    recipient: PICKUP_RECIPIENTS[supplierKind] ?? "",
  };
}
